import { render, staticRenderFns } from "./SwiperPopup.vue?vue&type=template&id=2cbd2825&scoped=true&"
import script from "./SwiperPopup.vue?vue&type=script&lang=js&"
export * from "./SwiperPopup.vue?vue&type=script&lang=js&"
import style0 from "./SwiperPopup.vue?vue&type=style&index=0&id=2cbd2825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd2825",
  null
  
)

export default component.exports